

/*import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ExaminationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}
export interface TypeOptions {
  value: number;
  title: string;
}

export interface Examination {
    id?: number;
    did?:number;
    type:string;
    name: string;
    
  parameters?: ExaminationParameter[];
  links?: any;
}

export abstract class ExaminationData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Examination[]>;
  abstract create(url: string,data: Examination): Observable<any>;
  abstract update(url: string,data: Examination): Observable<any>;
  abstract delete(url: string): Observable<any>;
}*/


import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ExaminationParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Examination {
    id?: number;
    departmentId?:string;
    type:string;
    name: string;
    tenantId: string;
    branchId?: string;
    univ_Code?: string;
    mappingAttribute?:string;
    isActive?:Boolean;
    parameters?: ExaminationParameter[];
    links?: any;
}
export interface TypeOptions {
  value: number;
  title: string;
}

export abstract class ExaminationData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Examination[]>;
  abstract create(url: string,data: Examination): Observable<any>;
  abstract update(url: string,data: Examination): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
